import classNames from "classnames";
import React, { CSSProperties } from "react";
import { Icon, IconName } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";

interface ButtonProps {
  title: string;
  testID?: string;
  onPress?: () => void;
  href?: string;
  target?: string;
  rel?: string;
  disabled?: boolean;
  size?: "lg" | "md";
  icon?: IconName;
  appearance?: "filled" | "outline" | "flat";
  override?: {
    button?: {
      style: CSSProperties;
    };
  };
}

export function Button(props: ButtonProps) {
  const {
    appearance = "filled",
    title,
    icon,
    disabled,
    testID,
    onPress,
    href,
    target,
    rel,
    size = "md",
    override,
  } = props;
  const { locale } = useI18n();

  const className = classNames(
    "button",
    `button-appearance-${appearance}`,
    `button-size-${size}`,
    disabled && "button-disabled",
    `button-${locale.baseLanguageTag}`
  );

  const content = (
    <>
      {icon && (
        <div className="button-icon">
          <Icon size={18} name={icon} color="white" />
        </div>
      )}
      {title}
    </>
  );

  if (href) {
    return (
      <a
        data-testid={testID}
        href={href}
        target={target}
        rel={rel}
        className={className}
        style={{
          textDecoration: "none",
          ...override?.button?.style,
        }}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      data-testid={testID}
      disabled={disabled}
      className={className}
      style={override?.button?.style}
      onClick={onPress}
    >
      {content}
    </button>
  );
}
